import {
  FILLING_CODE_OPTIONS,
  INCOME_ESTIMATE_OPTIONS,
  US_STATES_OPTIONS
} from "../../constants/user";
import { Quarter } from "@wingspanhq/utils/dist/date/taxDeadlines";
import { TaxQuarter } from "@wingspanhq/bookkeeping/dist/lib/interfaces/taxEstimate";

export function formatFilingCode(filingCode?: string) {
  return FILLING_CODE_OPTIONS.find(option => option.value === filingCode)
    ?.label;
}

export function formatIncomeEstimate(incomeEstimate?: number) {
  return INCOME_ESTIMATE_OPTIONS.find(option => option.value === incomeEstimate)
    ?.label;
}

export function formatStateOfResidence(stateOfResidence?: string) {
  return US_STATES_OPTIONS.find(option => option.value === stateOfResidence)
    ?.label;
}
export const QUARTER_TO_TAX_QUARTER: Record<Quarter, TaxQuarter> = {
  [Quarter.Q1]: TaxQuarter.q1,
  [Quarter.Q2]: TaxQuarter.q2,
  [Quarter.Q3]: TaxQuarter.q3,
  [Quarter.Q4]: TaxQuarter.q4
};
